<template>
  <v-dialog
    v-model="dialog"
    max-width="700px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="ma-0"
        outlined
        fab
        x-small
        v-bind="attrs"
        color="primary"
        v-on="on"
      >
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </template>
    <v-toolbar
      :flat="true"
      color="secondary"
      dark
      class="pl-5"
    >
      <v-toolbar-title>Voyage Parameters & Constraints</v-toolbar-title>
    </v-toolbar>
    <v-tabs
      v-model="tab"
      vertical
      background-color="var(--color-bg)"
    >
      <v-tab>
        <v-icon
          left
          color="var(--color-text)"
        >
          mdi-navigation-outline
        </v-icon>
        <span class="text-color-text">Navigation</span>
      </v-tab>

      <v-tab>
        <v-icon
          left
          color="var(--color-text)"
        >
          mdi-axis-lock
        </v-icon>
        <span class="text-color-text">Constraints</span>
      </v-tab>

      <v-tab>
        <v-icon
          left
          color="var(--color-text)"
        >
          mdi-currency-usd
        </v-icon>
        <span class="text-color-text">Costs</span>
      </v-tab>

      <v-tab>
        <v-icon
          left
          color="var(--color-text)"
        >
          mdi-routes
        </v-icon>
        <span class="text-color-text">No-go Areas</span>
      </v-tab>

      <v-tabs-items
        v-model="tab"
        class="tab-items"
      >
        <v-tab-item>
          <NavigationSettings />
        </v-tab-item>
        <v-tab-item>
          <ConstraintSettings />
        </v-tab-item>
        <v-tab-item>
          <CostSettings />
        </v-tab-item>
        <v-tab-item>
          <NoGoAreasSettings />
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </v-dialog>
</template>

<script>
import ConstraintSettings from "./ConstraintSettings.vue";
import CostSettings from "./CostSettings.vue";
import NavigationSettings from "./NavigationSettings.vue";
import NoGoAreasSettings from "./NoGoAreasSettings.vue";
export default {
  name: "EditExtraVoyageSettings",
  components: {
    NavigationSettings,
    ConstraintSettings,
    CostSettings,
    NoGoAreasSettings,
  },
  data: () => ({
    dialog: false,
    tab: 0,
  }),
};
</script>

<style scoped>
.text-color-text {
  color: var(--color-text);
}

.tab-items {
  background-color: var(--color-surface) !important;
}
</style>
